/**
 * Cache Configuration Constants
 *
 * Centralized cache configuration for React Query and other caching mechanisms.
 * All time values are in milliseconds.
 *
 * @module cacheConfig
 */

/**
 * Field values cache configuration
 *
 * Used for caching unique field values for filter dropdowns.
 * These values don't change frequently, so we can cache them for longer periods.
 */
export const FIELD_VALUES_CACHE = {
  /**
   * Time before data is considered stale and needs refetching
   * 10 minutes - field values rarely change
   */
  STALE_TIME: 10 * 60 * 1000,

  /**
   * Time before unused cache entries are garbage collected
   * 30 minutes - keep in memory for user's session
   */
  GC_TIME: 30 * 60 * 1000,
} as const;
